"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowTargetLanguage = exports.TypeScriptTargetLanguage = exports.TypeScriptFlowBaseTargetLanguage = exports.tsFlowOptions = void 0;
const RendererOptions_1 = require("../../RendererOptions");
const JavaScript_1 = require("../JavaScript");
const FlowRenderer_1 = require("./FlowRenderer");
const TypeScriptRenderer_1 = require("./TypeScriptRenderer");
exports.tsFlowOptions = Object.assign({}, JavaScript_1.javaScriptOptions, {
    justTypes: new RendererOptions_1.BooleanOption("just-types", "Interfaces only", false),
    nicePropertyNames: new RendererOptions_1.BooleanOption("nice-property-names", "Transform property names to be JavaScripty", false),
    declareUnions: new RendererOptions_1.BooleanOption("explicit-unions", "Explicitly name unions", false),
    preferUnions: new RendererOptions_1.BooleanOption("prefer-unions", "Use union type instead of enum", false),
    preferTypes: new RendererOptions_1.BooleanOption("prefer-types", "Use types instead of interfaces", false),
    preferConstValues: new RendererOptions_1.BooleanOption("prefer-const-values", "Use string instead of enum for string enums with single value", false),
    readonly: new RendererOptions_1.BooleanOption("readonly", "Use readonly type members", false)
});
class TypeScriptFlowBaseTargetLanguage extends JavaScript_1.JavaScriptTargetLanguage {
    getOptions() {
        return [
            exports.tsFlowOptions.justTypes,
            exports.tsFlowOptions.nicePropertyNames,
            exports.tsFlowOptions.declareUnions,
            exports.tsFlowOptions.runtimeTypecheck,
            exports.tsFlowOptions.runtimeTypecheckIgnoreUnknownProperties,
            exports.tsFlowOptions.acronymStyle,
            exports.tsFlowOptions.converters,
            exports.tsFlowOptions.rawType,
            exports.tsFlowOptions.preferUnions,
            exports.tsFlowOptions.preferTypes,
            exports.tsFlowOptions.preferConstValues,
            exports.tsFlowOptions.readonly
        ];
    }
    get supportsOptionalClassProperties() {
        return true;
    }
}
exports.TypeScriptFlowBaseTargetLanguage = TypeScriptFlowBaseTargetLanguage;
class TypeScriptTargetLanguage extends TypeScriptFlowBaseTargetLanguage {
    constructor() {
        super("TypeScript", ["typescript", "ts", "tsx"], "ts");
    }
    makeRenderer(renderContext, untypedOptionValues) {
        return new TypeScriptRenderer_1.TypeScriptRenderer(this, renderContext, (0, RendererOptions_1.getOptionValues)(exports.tsFlowOptions, untypedOptionValues));
    }
}
exports.TypeScriptTargetLanguage = TypeScriptTargetLanguage;
class FlowTargetLanguage extends TypeScriptFlowBaseTargetLanguage {
    constructor() {
        super("Flow", ["flow"], "js");
    }
    makeRenderer(renderContext, untypedOptionValues) {
        return new FlowRenderer_1.FlowRenderer(this, renderContext, (0, RendererOptions_1.getOptionValues)(exports.tsFlowOptions, untypedOptionValues));
    }
}
exports.FlowTargetLanguage = FlowTargetLanguage;
